<template>
	<div class="page_customers">
		<section class="container-1200" style="margin-top: 40px;">
		</section>

		<div class="customer_container">
			<div class="customer_contant">
				<div class="list_menu">
					<div v-for="(item, index) in customersMenuList"
						:class="menuActiveIndex == index ? 'menu_item menu_item_active' : 'menu_item'"
						@click="onMenuClick(index)">{{ item }}</div>
				</div>
				<div class="customer_box">
					<!-- <wosByPubVue></wosByPubVue> -->
					<div class="customer_comment_title">Journals</div>
					<CustomerList :data="partmersJournalList" :isShowTitle="false" :isShowUAImage="true"
						:isShowStatistics="false"></CustomerList>

					<div class="customer_comment_title">Publishers</div>
					<CustomerList :data="partmersPublisherList" :isShowTitle="false" :isShowUAImage="true"
						:isShowStatistics="false"></CustomerList>

					<div class="customer_comment_title">Membership</div>
					<CustomerList :data="membershipCustomerList" :isShowTitle="false" :isShowUAImage="true"
						:isShowStatistics="false">
					</CustomerList>
				</div>
			</div>
		</div>

		<div class="customer_comment" v-if="false">
			<EvaluateIssue :isShowEvaluate="true" :isShowEvaluateTitle="false" :isShowFaq="false"></EvaluateIssue>
		</div>
	</div>

</template>
<script>
import { partmersJournalList, partmersPublisherList, customersMenuList } from "./data"
import { MEMBERSHIP_LOGOS } from "@/components/membershipList/membershipLogos"
import CustomerList from "@/components/customerList/index.vue"
import EvaluateIssue from "@/components/evaluateIssue/index.vue"
import wosByPubVue from "./components/wosByPub.vue";

export default {
	name: "clients",
	components: {
		CustomerList,
		EvaluateIssue,
		wosByPubVue
	},
	data() {
		return {
			commemt_about: [{
				img: require('@/assets/images/team1.png'), //头像
				name: 'Hossein Moayedi', //名字
				profile: 'Duy Tân University, Engineering Computer Science Chemistry Environmental Sciences & Ecology Materials Science.', //简介
			},
			{
				img: require('@/assets/images/team2.png'), //头像
				name: 'AL DIWANIYAH, IRAQ', //名字
				profile: 'University of Al-QadisiyahSch Educ,Science & Technology - Other Topics.', //简介
			}, {
				img: require('@/assets/images/team3.png'), //头像
				name: 'Dr. Abdulrahman S Bazaid', //名字
				profile: 'Department of Medical Laboratory Science, College of Applied Medical Sciences, University of Ha’il, Ha’il.', //简介
			},
			],
			partmersJournalList,
			partmersPublisherList,
			customersMenuList,
			menuActiveIndex: 0,
		};
	},
	computed: {
		membershipCustomerList() {
			return MEMBERSHIP_LOGOS.filter((logo) => logo.syncToCustomers !== false).map((logo) => ({
				image: logo.src,
				link: logo.link,
				text: "",
				...(logo.backgroundColor ? { backgroundColor: logo.backgroundColor } : {})
			}))
		}
	},
	watch: {},
	created() {

	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll, { passive: true })
	},
	beforeUnmount() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods: {
		onMenuClick(index) {
			this.menuActiveIndex = index
			const list = document.querySelectorAll('.customer_comment_title')
			if (!list.length || !list[index]) return

			const target = list[index]
			const top = target.getBoundingClientRect().top + window.scrollY

			const offset = 200

			window.scrollTo({
				top: top - offset,
				behavior: 'smooth'
			})
		},
		handleScroll() {
			const list = document.querySelectorAll('.customer_comment_title')
			if (!list.length) return

			const offset = 200  // 顶部固定导航高度

			let currentIndex = 0

			list.forEach((el, idx) => {
				const rect = el.getBoundingClientRect()

				// rect.top <= offset   表示滚动已到达或超过此标题区域
				if (rect.top - offset <= 0) {
					currentIndex = idx
				}
			})

			if (this.menuActiveIndex !== currentIndex) {
				this.menuActiveIndex = currentIndex
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.page_customers {
	.customer_container {
		background-color: #f6fafc;
		display: flex;
		justify-content: center;

		.customer_contant {
			display: flex;
			position: relative;

			.list_menu {
				position: fixed;
				top: 234px;

				.menu_item {
					padding: 10px 18px;
					border-radius: 10px;
					transition: all 0.3s;
					color: #333;
					font-size: 16px;
					font-weight: bold;
					width: 180px;
					box-sizing: border-box;

					&:hover {
						color: #189eae;
						cursor: pointer;
					}
				}

				.menu_item_active {
					background-color: white;
					color: #1da6b8;
				}
			}
		}
	}

	.customer_box {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-left: 200px;
		box-sizing: border-box;
		width: 1200px;

		.customer_list {
			width: auto;
			align-items: normal;
		}

		::v-deep .list_item {
			flex: 0 0 31%;
		}
	}

	.customer_comment {
		margin-top: 30px;
	}

	.customer_comment_title {
		font-size: 26px;
		font-weight: bold;
		color: #393939;
		margin: 20px 30px;
		text-align: center;
	}
}

@media screen and (max-width: 768px) {
	.page_customers {
		.customer_box {
			padding-left: 0;
			width: auto;

			::v-deep .list_item {
				flex: 0 0 100%;
			}
		}

		.list_menu {
			display: none;
		}
	}
}

.customerImg1 {
	margin-left: 15px;
}

.customerImg img {
	width: 200px;
	height: 70px;
	margin-bottom: 15px;
}

.comment {
	border: 1px solid #eee;
	display: flex;
	align-items: center;
}

.avatar {
	flex: 2;
	display: flex;
	justify-content: center;
	align-items: center;
}

.avatarImage {
	padding: 25px 0px;
	width: 120px;
	height: 120px;
	border-radius: 50%;
}

.comment_content {
	flex: 8;
}

.comment_content p {
	padding: 0px 20px;
}

/* 轮播形式 */
.el-carousel__item h3 {
	color: #475669;
	font-size: 18px;
	opacity: 0.75;
	line-height: 300px;
	margin: 0;
}

.el-carousel__item {
	height: unset;
}
</style>